import React, { ReactElement } from 'react';

import { BlindType } from '../../model/enumeration/BlindType.enum';
import { PlayerActionType } from '../../model/enumeration/PlayerActionType.enum';

const getBlinds = (blinds: BlindType[]): ReactElement[] => {
  if (!blinds) {
    return null;
  }
  return blinds.map(blind => {
    let abbreviature = '';
    switch (blind) {
      case BlindType.TYPE_BB:
        abbreviature = 'BB';
        break;
      case BlindType.TYPE_SB:
        abbreviature = 'SB';
        break;
      case BlindType.TYPE_STRADDLE:
        abbreviature = 'ST';
        break;
      case BlindType.TYPE_SBB:
        abbreviature = 'SBB';
        break;
      case BlindType.TYPE_BB_IN_FRONT:
        abbreviature = 'BBF';
        break;
      case BlindType.TYPE_BLIND_BB_TO_MID:
        abbreviature = 'BBM';
        break;
      case BlindType.TYPE_BLIND_SB_TO_MID:
        abbreviature = 'SBM';
        break;
    }
    return (
      <h3 className="sb m-1" key={abbreviature}>
        {abbreviature}
      </h3>
    );
  });
};

export const ACTION_COLORS = new Map<PlayerActionType | BlindType, string>([
  [PlayerActionType.BET, '#d3a86c'],
  [PlayerActionType.CALL, '#77d29b'],
  [PlayerActionType.CHECK, '#93b2e3'],
  [PlayerActionType.RAISE, '#a799ec'],
  [PlayerActionType.SB, ''],
  [PlayerActionType.BB, ''],
  [PlayerActionType.STRADDLE, '#69b7d9'],
  [PlayerActionType.FOLD, '#d95b5b'],
  [BlindType.TYPE_ANTE, '#69b7d9'],
  [BlindType.TYPE_SB, ''],
  [BlindType.TYPE_BB, ''],
  [BlindType.TYPE_STRADDLE, '#69b7d9'],
  [BlindType.TYPE_SBB, ''],
  [BlindType.TYPE_BLIND_SB_TO_MID, ''],
  [BlindType.TYPE_BLIND_BB_TO_MID, ''],
  [BlindType.TYPE_BB_IN_FRONT, ''],
]);

export default getBlinds;
